import { lazyComponent } from '@/components/common/utils/lazyImport';

export const LazyMapDemoControls = lazyComponent(
  () => import(/* webpackChunkName: 'MapDemoControls' */ './MapDemoControls'),
  { preload: true },
);
